"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Robot = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Robot"));

var PricingError =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PricingError, _PureComponent);

  function PricingError() {
    (0, _classCallCheck2.default)(this, PricingError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PricingError).apply(this, arguments));
  }

  (0, _createClass2.default)(PricingError, [{
    key: "render",
    value: function render() {
      var _this$props$message$e = this.props.message.error,
          shortMessage = _this$props$message$e.shortMessage,
          detailedMessage = _this$props$message$e.detailedMessage;
      return _react.default.createElement("div", {
        className: "vertical-container flex-center"
      }, _react.default.createElement(_Robot.default, {
        bsStyle: "danger"
      }), _react.default.createElement("h4", null, shortMessage), _react.default.createElement("h6", null, detailedMessage));
    }
  }]);
  return PricingError;
}(_react.PureComponent);

exports.default = PricingError;